/* Ambient Home — theme scripts */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- mobile menu ---- */
  var menu = $('[data-menu]');
  function openMenu() { if (!menu) return; menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { if (!menu) return; menu.classList.remove('is-open'); document.body.style.overflow = ''; }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  $$('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.nextElementSibling;
      if (!sub) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      sub.classList.toggle('is-open', !open);
    });
  });

  /* ---- search overlay ---- */
  var search = $('[data-search]');
  function openSearch() {
    if (!search) return;
    search.classList.add('is-open');
    var i = $('input[type=search]', search);
    if (i) setTimeout(function () { i.focus(); }, 60);
  }
  function closeSearch() { if (search) search.classList.remove('is-open'); }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeSearch(); }
  });

  /* ---- accordions ---- */
  $$('[data-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.classList.toggle('is-open', !open);
    });
  });

  /* ---- quantity steppers ---- */
  $$('[data-qty]').forEach(function (box) {
    var input = $('input', box);
    if (!input) return;
    $$('button', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-qty-step') === 'up' ? 1 : -1;
        var min = parseInt(input.min || '1', 10);
        var max = input.max ? parseInt(input.max, 10) : Infinity;
        var next = (parseInt(input.value, 10) || min) + step;
        if (next < min) next = min;
        if (next > max) next = max;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- product gallery ---- */
  $$('[data-gallery]').forEach(function (gal) {
    var main = $('[data-gallery-main]', gal);
    if (!main) return;
    $$('[data-gallery-thumb]', gal).forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; if (main.srcset) main.srcset = ''; }
        $$('[data-gallery-thumb]', gal).forEach(function (o) { o.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });
  });

  /* ---- collection sort ---- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---- cart line quantity auto-submit ---- */
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---- header shadow on scroll ---- */
  var hdr = $('.hdr');
  if (hdr) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if ((y > 8) !== (last > 8)) hdr.style.boxShadow = y > 8 ? 'var(--sh-m)' : '';
      last = y;
    }, { passive: true });
  }
})();
